var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab shop"},[_c('div',[_vm._v(" STD's cannot be bought on games made with the Break Eternity port of AD."),_c('br'),_vm._v(" You know, this is a mod. Go purchase them in the orginal game. ")])])
}]

export { render, staticRenderFns }